// @flow
import {BREAKPOINTS, breakpointFromDeviceFlags} from '../utils/breakpoints';

import type {
    Action,
    ViewportSizeChangedAction,
    ViewportUserAgentChangedAction
} from '../actions/viewport';
import type {Breakpoint} from '../utils/breakpoints';

export type State = {
    +breakpoint: Breakpoint
};

const initialState = {
    breakpoint: 'XS_MIN'
};

const breakpointNames = Object.keys(BREAKPOINTS);

function sizeChanged(
    state: State,
    {payload: {width}}: ViewportSizeChangedAction
): State {
    let breakpoint = breakpointNames[0];

    for (let i = 0; i < breakpointNames.length; i++) {
        let next = breakpointNames[i];
        if (BREAKPOINTS[next] > width) {
            break;
        } else {
            breakpoint = next;
        }
    }
    return {...state, breakpoint};
}

function userAgentChanged(
    state: State,
    {payload: flags}: ViewportUserAgentChangedAction
): State {
    return {...state, breakpoint: breakpointFromDeviceFlags(flags)};
}

export default function reducer(
    state: State = initialState,
    action: Action
): State {
    switch (action.type) {
        case 'VIEWPORT/SIZE_CHANGED':
            return sizeChanged(state, action);

        case 'VIEWPORT/USER_AGENT_CHANGED':
            return userAgentChanged(state, action);

        default:
            // Ensures we have handled every single action type
            // by casting the action to `empty` in the default case.
            // If Flow finds it possible to reach this case, the empty
            // cast will fail.
            (action: empty); // eslint-disable-line no-unused-expressions
            return state;
    }
}
